export const decodeHtml = (html) => {
    if (!html) return '';

    const textarea = document.createElement('textarea');

    textarea.innerHTML = html;

    return textarea.value;
};
